// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Manager - Clean Modern Theme */
.device-manager {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--dashboard-space-6);
}

/* Header */
.device-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--dashboard-space-8);
  padding: var(--dashboard-space-6);
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  backdrop-filter: blur(20px);
}

.device-header h2 {
  margin: 0;
  color: var(--dashboard-text-primary);
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.add-device-btn {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border: none;
  padding: var(--dashboard-space-3) var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
  transition: all 0.2s ease;
  box-shadow: var(--dashboard-shadow-md);
  position: relative;
  overflow: hidden;
}

.add-device-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s;
}

.add-device-btn:hover::before {
  left: 100%;
}

.add-device-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--dashboard-shadow-lg);
}

.add-device-btn span {
  font-size: 1.125rem;
  font-weight: 700;
}

/* Devices Grid */
.devices-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: var(--dashboard-space-6);
}

/* No Devices State */
.no-devices {
  grid-column: 1 / -1;
  text-align: center;
  padding: var(--dashboard-space-12) var(--dashboard-space-8);
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  border: 1px solid var(--dashboard-border);
  backdrop-filter: blur(20px);
}

.no-devices-icon {
  font-size: 4rem;
  margin-bottom: var(--dashboard-space-4);
  opacity: 0.6;
}

.no-devices h3 {
  margin: 0 0 var(--dashboard-space-3) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.5rem;
  font-weight: 600;
}

.no-devices p {
  margin: 0 0 var(--dashboard-space-6) 0;
  color: var(--dashboard-text-secondary);
  font-size: 1rem;
  line-height: 1.6;
}

.add-first-device-btn {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border: none;
  padding: var(--dashboard-space-4) var(--dashboard-space-8);
  border-radius: var(--dashboard-radius-lg);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: var(--dashboard-shadow-md);
}

.add-first-device-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--dashboard-shadow-lg);
}

/* Device Card */
.device-card {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  border: 1px solid var(--dashboard-border);
  padding: var(--dashboard-space-6);
  transition: all 0.3s ease;
  backdrop-filter: blur(20px);
  position: relative;
  overflow: hidden;
}

.device-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.device-card:hover::before {
  opacity: 0.02;
}

.device-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--dashboard-shadow-lg);
  border-color: var(--dashboard-primary);
}

/* Device Card Header */
.device-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--dashboard-space-6);
  position: relative;
  z-index: 2;
}

.device-info h3 {
  margin: 0 0 var(--dashboard-space-1) 0;
  color: var(--dashboard-text-primary);
  font-size: 1.25rem;
  font-weight: 600;
}

.device-phone {
  margin: 0;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  font-family: 'Monaco', 'Menlo', monospace;
}

/* Device Status */
.device-status-container {
  text-align: right;
}

.device-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: var(--dashboard-radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: var(--dashboard-space-1);
  color: white;
}

.status-description {
  display: block;
  color: var(--dashboard-text-secondary);
  font-size: 0.75rem;
  line-height: 1.4;
}

/* Device Details */
.device-details {
  margin-bottom: var(--dashboard-space-6);
  position: relative;
  z-index: 2;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dashboard-space-3) 0;
  border-bottom: 1px solid var(--dashboard-border);
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-item .label {
  font-weight: 600;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
}

.detail-item .value {
  color: var(--dashboard-text-primary);
  font-size: 0.875rem;
  font-family: 'Monaco', 'Menlo', monospace;
}

/* Device Actions */
.device-actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dashboard-space-3);
  align-items: center;
  position: relative;
  z-index: 2;
}

.action-btn {
  padding: var(--dashboard-space-2) var(--dashboard-space-4);
  border-radius: var(--dashboard-radius-md);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1 1;
  min-width: 80px;
}

.action-btn.primary {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
}

.action-btn.primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--dashboard-shadow-md);
}

.action-btn.secondary {
  background: var(--dashboard-bg-secondary);
  color: var(--dashboard-text-primary);
  border: 1px solid var(--dashboard-border);
}

.action-btn.secondary:hover {
  background: var(--dashboard-bg-hover);
}

.action-btn.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
}

.action-btn.warning:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.action-btn.success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
}

.action-btn.success:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* User Message */
.user-message {
  flex: 1 1;
  padding: var(--dashboard-space-3);
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-md);
  border: 1px solid var(--dashboard-border);
}

.status-message {
  margin: 0;
  color: var(--dashboard-text-secondary);
  font-size: 0.875rem;
  line-height: 1.4;
  text-align: center;
}

/* Device Menu */
.device-menu {
  position: relative;
  flex-shrink: 0;
  z-index: 10;
}

.menu-btn {
  background: var(--dashboard-bg-secondary);
  border: 1px solid var(--dashboard-border);
  color: var(--dashboard-text-secondary);
  width: 32px;
  height: 32px;
  border-radius: var(--dashboard-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
  font-weight: bold;
}

.menu-btn:hover {
  background: var(--dashboard-bg-hover);
  color: var(--dashboard-text-primary);
}

.menu-btn.active {
  background: var(--dashboard-primary);
  color: white;
}

.menu-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  background: white;
  border: 2px solid #333;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  min-width: 120px;
  z-index: 99999;
  display: none;
}

.menu-dropdown.active {
  display: block !important;
}

.menu-dropdown button {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  color: #333;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.menu-dropdown button:first-child {
  border-radius: 6px 6px 0 0;
}

.menu-dropdown button:last-child {
  border-radius: 0 0 6px 6px;
}

.menu-dropdown button:hover {
  background: #f0f0f0;
}

.menu-dropdown button.delete-action {
  color: #dc2626;
}

.menu-dropdown button.delete-action:hover {
  background: #fee2e2;
  color: #b91c1c;
}

/* Device Actions Menu */
.device-actions-menu {
  display: flex;
  gap: var(--dashboard-space-2);
  align-items: center;
}

.action-icon-btn {
  background: var(--dashboard-bg-secondary);
  border: 1px solid var(--dashboard-border);
  width: 32px;
  height: 32px;
  border-radius: var(--dashboard-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  padding: 0;
}

.action-icon-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--dashboard-shadow-md);
}

.action-icon-btn.secondary {
  color: #6b7280;
  border-color: #6b7280;
}

.action-icon-btn.secondary:hover {
  background: #f3f4f6;
  border-color: #4b5563;
}

.action-icon-btn.warning {
  color: #f59e0b;
  border-color: #f59e0b;
}

.action-icon-btn.warning:hover {
  background: #fef3c7;
  border-color: #d97706;
}

.action-icon-btn.primary {
  color: #3b82f6;
  border-color: #3b82f6;
}

.action-icon-btn.primary:hover {
  background: #dbeafe;
  border-color: #2563eb;
}

.edit-btn {
  color: #0066cc;
  border-color: #0066cc;
}

.edit-btn:hover {
  background: #e6f3ff;
  border-color: #0052a3;
}

.delete-btn {
  color: #dc2626;
  border-color: #dc2626;
}

.delete-btn:hover {
  background: #fee2e2;
  border-color: #b91c1c;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .device-manager {
    padding: var(--dashboard-space-4);
    width: 100%;
    min-height: auto;
    overflow: visible;
  }
  
  .device-header {
    flex-direction: column;
    gap: var(--dashboard-space-4);
    text-align: center;
  }
  
  .devices-grid {
    grid-template-columns: 1fr;
    gap: var(--dashboard-space-4);
    width: 100%;
  }
  
  .device-card {
    width: 100%;
    margin-bottom: var(--dashboard-space-4);
  }
  
  .device-card-header {
    flex-direction: column;
    gap: var(--dashboard-space-3);
    text-align: center;
  }
  
  .device-status-container {
    text-align: center;
  }
  
  .device-actions {
    flex-direction: column;
  }
  
  .action-btn {
    flex: none;
    width: 100%;
  }
  
  .menu-dropdown {
    right: auto;
    left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DeviceManager.css"],"names":[],"mappings":"AAAA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oGAAoG;EACpG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,YAAY;EACZ,0DAA0D;EAC1D,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2DAA2D;EAC3D,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,YAAY;EACZ,0DAA0D;EAC1D,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,yCAAyC;EACzC,yCAAyC;EACzC,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iGAAiG;EACjG,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0DAA0D;EAC1D,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,iGAAiG;EACjG,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uCAAuC;EACzC;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,OAAO;EACT;AACF","sourcesContent":["/* Device Manager - Clean Modern Theme */\n.device-manager {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: var(--dashboard-space-6);\n}\n\n/* Header */\n.device-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--dashboard-space-8);\n  padding: var(--dashboard-space-6);\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  backdrop-filter: blur(20px);\n}\n\n.device-header h2 {\n  margin: 0;\n  color: var(--dashboard-text-primary);\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.add-device-btn {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border: none;\n  padding: var(--dashboard-space-3) var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n  transition: all 0.2s ease;\n  box-shadow: var(--dashboard-shadow-md);\n  position: relative;\n  overflow: hidden;\n}\n\n.add-device-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.5s;\n}\n\n.add-device-btn:hover::before {\n  left: 100%;\n}\n\n.add-device-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n.add-device-btn span {\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n\n/* Devices Grid */\n.devices-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: var(--dashboard-space-6);\n}\n\n/* No Devices State */\n.no-devices {\n  grid-column: 1 / -1;\n  text-align: center;\n  padding: var(--dashboard-space-12) var(--dashboard-space-8);\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  border: 1px solid var(--dashboard-border);\n  backdrop-filter: blur(20px);\n}\n\n.no-devices-icon {\n  font-size: 4rem;\n  margin-bottom: var(--dashboard-space-4);\n  opacity: 0.6;\n}\n\n.no-devices h3 {\n  margin: 0 0 var(--dashboard-space-3) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.no-devices p {\n  margin: 0 0 var(--dashboard-space-6) 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.add-first-device-btn {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border: none;\n  padding: var(--dashboard-space-4) var(--dashboard-space-8);\n  border-radius: var(--dashboard-radius-lg);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.add-first-device-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n/* Device Card */\n.device-card {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  border: 1px solid var(--dashboard-border);\n  padding: var(--dashboard-space-6);\n  transition: all 0.3s ease;\n  backdrop-filter: blur(20px);\n  position: relative;\n  overflow: hidden;\n}\n\n.device-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.device-card:hover::before {\n  opacity: 0.02;\n}\n\n.device-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--dashboard-shadow-lg);\n  border-color: var(--dashboard-primary);\n}\n\n/* Device Card Header */\n.device-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: var(--dashboard-space-6);\n  position: relative;\n  z-index: 2;\n}\n\n.device-info h3 {\n  margin: 0 0 var(--dashboard-space-1) 0;\n  color: var(--dashboard-text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.device-phone {\n  margin: 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n/* Device Status */\n.device-status-container {\n  text-align: right;\n}\n\n.device-status {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: var(--dashboard-radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: var(--dashboard-space-1);\n  color: white;\n}\n\n.status-description {\n  display: block;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n/* Device Details */\n.device-details {\n  margin-bottom: var(--dashboard-space-6);\n  position: relative;\n  z-index: 2;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--dashboard-space-3) 0;\n  border-bottom: 1px solid var(--dashboard-border);\n}\n\n.detail-item:last-child {\n  border-bottom: none;\n}\n\n.detail-item .label {\n  font-weight: 600;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n}\n\n.detail-item .value {\n  color: var(--dashboard-text-primary);\n  font-size: 0.875rem;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n/* Device Actions */\n.device-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--dashboard-space-3);\n  align-items: center;\n  position: relative;\n  z-index: 2;\n}\n\n.action-btn {\n  padding: var(--dashboard-space-2) var(--dashboard-space-4);\n  border-radius: var(--dashboard-radius-md);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex: 1;\n  min-width: 80px;\n}\n\n.action-btn.primary {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n}\n\n.action-btn.primary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.action-btn.secondary {\n  background: var(--dashboard-bg-secondary);\n  color: var(--dashboard-text-primary);\n  border: 1px solid var(--dashboard-border);\n}\n\n.action-btn.secondary:hover {\n  background: var(--dashboard-bg-hover);\n}\n\n.action-btn.warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n}\n\n.action-btn.warning:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);\n}\n\n.action-btn.success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n}\n\n.action-btn.success:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* User Message */\n.user-message {\n  flex: 1;\n  padding: var(--dashboard-space-3);\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-md);\n  border: 1px solid var(--dashboard-border);\n}\n\n.status-message {\n  margin: 0;\n  color: var(--dashboard-text-secondary);\n  font-size: 0.875rem;\n  line-height: 1.4;\n  text-align: center;\n}\n\n/* Device Menu */\n.device-menu {\n  position: relative;\n  flex-shrink: 0;\n  z-index: 10;\n}\n\n.menu-btn {\n  background: var(--dashboard-bg-secondary);\n  border: 1px solid var(--dashboard-border);\n  color: var(--dashboard-text-secondary);\n  width: 32px;\n  height: 32px;\n  border-radius: var(--dashboard-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.menu-btn:hover {\n  background: var(--dashboard-bg-hover);\n  color: var(--dashboard-text-primary);\n}\n\n.menu-btn.active {\n  background: var(--dashboard-primary);\n  color: white;\n}\n\n.menu-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  right: 0;\n  background: white;\n  border: 2px solid #333;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.3);\n  min-width: 120px;\n  z-index: 99999;\n  display: none;\n}\n\n.menu-dropdown.active {\n  display: block !important;\n}\n\n.menu-dropdown button {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  color: #333;\n  text-align: left;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.menu-dropdown button:first-child {\n  border-radius: 6px 6px 0 0;\n}\n\n.menu-dropdown button:last-child {\n  border-radius: 0 0 6px 6px;\n}\n\n.menu-dropdown button:hover {\n  background: #f0f0f0;\n}\n\n.menu-dropdown button.delete-action {\n  color: #dc2626;\n}\n\n.menu-dropdown button.delete-action:hover {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n/* Device Actions Menu */\n.device-actions-menu {\n  display: flex;\n  gap: var(--dashboard-space-2);\n  align-items: center;\n}\n\n.action-icon-btn {\n  background: var(--dashboard-bg-secondary);\n  border: 1px solid var(--dashboard-border);\n  width: 32px;\n  height: 32px;\n  border-radius: var(--dashboard-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  padding: 0;\n}\n\n.action-icon-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.action-icon-btn.secondary {\n  color: #6b7280;\n  border-color: #6b7280;\n}\n\n.action-icon-btn.secondary:hover {\n  background: #f3f4f6;\n  border-color: #4b5563;\n}\n\n.action-icon-btn.warning {\n  color: #f59e0b;\n  border-color: #f59e0b;\n}\n\n.action-icon-btn.warning:hover {\n  background: #fef3c7;\n  border-color: #d97706;\n}\n\n.action-icon-btn.primary {\n  color: #3b82f6;\n  border-color: #3b82f6;\n}\n\n.action-icon-btn.primary:hover {\n  background: #dbeafe;\n  border-color: #2563eb;\n}\n\n.edit-btn {\n  color: #0066cc;\n  border-color: #0066cc;\n}\n\n.edit-btn:hover {\n  background: #e6f3ff;\n  border-color: #0052a3;\n}\n\n.delete-btn {\n  color: #dc2626;\n  border-color: #dc2626;\n}\n\n.delete-btn:hover {\n  background: #fee2e2;\n  border-color: #b91c1c;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .device-manager {\n    padding: var(--dashboard-space-4);\n    width: 100%;\n    min-height: auto;\n    overflow: visible;\n  }\n  \n  .device-header {\n    flex-direction: column;\n    gap: var(--dashboard-space-4);\n    text-align: center;\n  }\n  \n  .devices-grid {\n    grid-template-columns: 1fr;\n    gap: var(--dashboard-space-4);\n    width: 100%;\n  }\n  \n  .device-card {\n    width: 100%;\n    margin-bottom: var(--dashboard-space-4);\n  }\n  \n  .device-card-header {\n    flex-direction: column;\n    gap: var(--dashboard-space-3);\n    text-align: center;\n  }\n  \n  .device-status-container {\n    text-align: center;\n  }\n  \n  .device-actions {\n    flex-direction: column;\n  }\n  \n  .action-btn {\n    flex: none;\n    width: 100%;\n  }\n  \n  .menu-dropdown {\n    right: auto;\n    left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
